<template>
  <section class="separator">
    <div class="content">
      <img class="border-image" src="../assets/images/stripe-tape.png" alt="" />

      <div class="intro">
        <div class="headline">
          <h2 class="headline__title">Создаем AI-решения будущего</h2>
          <p class="headline__subtitle">
            Работаем с современными AI-технологиями, автоматизируем
            бизнес-процессы и создаем продукты, которыми пользуются тысячи
            людей. Если тебе интересно развиваться в сильной команде — тебе к
            нам.
          </p>
        </div>

        <div class="feature-cards">
          <div
            v-for="(card, index) in cards"
            :key="card.title"
            class="feature-item"
            :class="[
              `feature-item--icon-${card.iconPosition}`,
              `feature-item--icon-size-${card.iconSize}`,
            ]"
          >
            <div
              class="feature-item__icon"
              :style="{ '--icon-z': index * 2 + 2 }"
              aria-hidden="true"
            >
              <img :src="card.icon" alt="" />
            </div>
            <article
              class="feature-card"
              :style="{ '--card-z': index * 2 + 1 }"
            >
              <h3 class="feature-card__title">{{ card.title }}</h3>
              <p class="feature-card__description">{{ card.description }}</p>
            </article>
          </div>
        </div>
      </div>

      <div class="center">
        <div class="left-text">
          AI-автоматизация<br />
          для бизнеса и команды
        </div>
        <div class="right-text">
          Автоматизируем процессы,<br />
          чтобы расти быстрее вместе
        </div>
      </div>

      <div class="rocket" aria-hidden="true">
        <img src="../assets/images/rocket.png" alt="" />
      </div>

      <img
        class="border-image bottom"
        src="../assets/images/stripe-tape.png"
        alt=""
      />
    </div>
  </section>
</template>

<script>
import botIcon from "../assets/images/bot-icon.svg";
import settingsIcon from "../assets/images/settings-icon.svg";
import usersIcon from "../assets/images/users-icon.svg";
import chartLineIcon from "../assets/images/chart-line-icon.svg";

export default {
  name: "SeparatorSection",

  data() {
    return {
      cards: [
        {
          title: "AI и автоматизация",
          description:
            "Разрабатываем интеллектуальные решения, которые помогают работать быстрее и эффективнее.",
          icon: botIcon,
          iconPosition: "top",
          iconSize: "lg",
        },
        {
          title: "Современный стек",
          description:
            "Используем передовые\nтехнологии, экспериментируем\nс AI и постоянно внедряем новые инструменты",
          icon: settingsIcon,
          iconPosition: "bottom",
          iconSize: "lg",
        },
        {
          title: "Сильная команда",
          description:
            "Работаем вместе, делимся опытом и растем как профессионалы каждый день.",
          icon: usersIcon,
          iconPosition: "top",
          iconSize: "md",
        },
        {
          title: "Развитие\nи возможности",
          description:
            "Сложные задачи, реальные проекты и возможность влиять на продукты компании",
          icon: chartLineIcon,
          iconPosition: "bottom",
          iconSize: "md",
        },
      ],
    };
  },
};
</script>

<style scoped lang="sass">
@import "../styles/variables.sass"

// Figma 6033:677 — 1440×743
.separator
  width: 100%
  background: #F8F7FF

  .content
    width: 100%
    display: flex
    flex-direction: column
    overflow: hidden
    position: relative

    .border-image
      width: fit-content
      max-width: 100%
      height: 30px
      display: block
      position: relative
      z-index: 3
      flex-shrink: 0

      @media screen and (min-width: $desktop_large)
        width: 100%

      &.bottom
        z-index: 9

    .intro
      display: flex
      flex-direction: column
      align-items: center
      gap: 24px
      padding: 48px 16px 24px
      width: 100%
      box-sizing: border-box
      position: relative
      // выше ракеты — нос уходит под карточки
      z-index: 3

      @media screen and (min-width: $tablet)
        gap: 28px
        padding: 56px 40px 32px

      @media screen and (min-width: $desktop_xs)
        gap: 48px
        padding: 64px 102px

      // Figma 1440: px 102, py 64, gap 40
      @media screen and (min-width: $desktop_small)
        gap: 40px
        padding: 64px 102px

    .headline
      display: flex
      flex-direction: column
      align-items: center
      gap: 12px
      text-align: center
      width: 100%

      @media screen and (min-width: $desktop_xs)
        gap: 16px

      &__title
        margin: 0
        width: 100%
        font-size: 40px
        font-weight: 600
        line-height: 44px
        color: #5E57BC

        @media screen and (min-width: $tablet)
          font-size: 48px
          line-height: 1.15

        @media screen and (min-width: $desktop_xs)
          font-size: 56px
          line-height: 72.8px

        @media screen and (min-width: $desktop_small)
          font-size: 50px
          line-height: 72.8px

        @media screen and (min-width: $desktop_medium)
          font-size: 56px

      &__subtitle
        margin: 0
        max-width: 920px
        width: 100%
        font-size: 18px
        font-weight: 500
        line-height: 24px
        color: #575393

        @media screen and (min-width: $tablet)
          font-size: 20px
          line-height: 28px

        @media screen and (min-width: $desktop_xs)
          font-size: 24px
          line-height: 32px

        @media screen and (min-width: $desktop_small)
          font-size: 22px
          line-height: 30px

        @media screen and (min-width: $desktop_medium)
          font-size: 24px
          line-height: 32px

    .feature-cards
      display: grid
      grid-template-columns: 1fr
      gap: 16px
      width: 100%
      box-sizing: border-box
      padding: 28px 53px 0 0

      @media screen and (min-width: $tablet)
        grid-template-columns: repeat(2, minmax(0, 1fr))
        gap: 20px
        padding: 36px 40px 0 0

      @media screen and (min-width: $desktop_xs)
        grid-template-columns: repeat(4, minmax(0, 1fr))
        gap: 20px
        padding: 0
        align-items: stretch

      @media screen and (min-width: $desktop_small)
        gap: 24px

    .feature-item
      position: relative
      width: 100%
      min-width: 0

      &__icon
        position: absolute
        top: -31px
        right: -53px
        z-index: var(--icon-z, 2)
        display: flex
        align-items: center
        justify-content: center
        width: 90px
        height: 90px
        border-radius: 34px
        background: #EEF2F8
        box-shadow: 0 0 6px 0 rgba(94, 87, 188, 0.16)
        pointer-events: none

        img
          width: 42%
          height: 42%
          object-fit: contain

        @media screen and (min-width: $tablet)
          width: 80px
          height: 80px
          border-radius: 25px
          top: -28px
          right: -28px

        @media screen and (min-width: $desktop_xs)
          width: 60px
          height: 60px
          border-radius: 19px
          right: -12px
          box-shadow: 0 0 3.4px 0 rgba(94, 87, 188, 0.16)

        @media screen and (min-width: $desktop_small)
          width: 80px
          height: 80px
          border-radius: 25px
          right: -27px
          box-shadow: 0 0 4.5px 0 rgba(94, 87, 188, 0.16)

        @media screen and (min-width: $desktop_medium)
          width: 107px
          height: 107px
          border-radius: 34px
          right: -29px
          box-shadow: 0 0 6px 0 rgba(94, 87, 188, 0.16)

      &--icon-size-lg .feature-item__icon img
        width: 50%
        height: 50%

      &--icon-top .feature-item__icon
        @media screen and (min-width: $tablet)
          top: -28px

        @media screen and (min-width: $desktop_xs)
          top: -7px

        @media screen and (min-width: $desktop_small)
          top: -12px

        @media screen and (min-width: $desktop_medium)
          top: -48px

      &--icon-bottom .feature-item__icon
        @media screen and (min-width: $tablet)
          top: auto
          bottom: -12px

        @media screen and (min-width: $desktop_xs)
          bottom: -8px

        @media screen and (min-width: $desktop_small)
          top: 134px
          bottom: auto

        @media screen and (min-width: $desktop_medium)
          top: auto
          bottom: -8px

    .feature-card
      position: relative
      z-index: var(--card-z, 1)
      display: flex
      flex-direction: column
      gap: 12px
      width: 100%
      height: 100%
      box-sizing: border-box
      padding: 24px
      background: rgba(255, 255, 255, 0.8)
      border: 1px solid rgba(255, 255, 255, 0.5)
      border-radius: 24px
      box-shadow: 0 0 12px 0 rgba(94, 87, 188, 0.16)
      text-align: left

      @media screen and (min-width: $desktop_xs)
        padding: 20px

      @media screen and (min-width: $desktop_small)
        min-height: 172px

      @media screen and (min-width: $desktop_medium)
        padding: 24px
        min-height: 0

      &__title
        margin: 0
        font-size: 24px
        font-weight: 700
        line-height: normal
        color: #5A54B9
        white-space: pre-line

        @media screen and (min-width: $desktop_xs)
          font-size: 20px

        @media screen and (min-width: $desktop_medium)
          font-size: 24px

      &__description
        margin: 0
        font-size: 18px
        font-weight: 400
        line-height: 1.5
        color: #1B2333
        white-space: normal
        overflow-wrap: break-word

        @media screen and (min-width: $desktop_xs)
          font-size: 14px

        @media screen and (min-width: $desktop_small)
          font-size: 16px
          white-space: pre-line

        @media screen and (min-width: $desktop_medium)
          font-size: 18px

    .center
      width: 100%
      box-sizing: border-box
      display: flex
      flex-wrap: wrap
      align-items: center
      justify-content: center
      gap: 16px
      padding: 16px
      position: relative
      // слоганы под ракетой (как слои в Figma)
      z-index: 1
      flex-shrink: 0

      @media screen and (min-width: $tablet)
        padding: 20px 40px

      @media screen and (min-width: $desktop_xs)
        flex-wrap: nowrap
        justify-content: space-between
        align-items: center
        padding: 24px 120px
        min-height: 140px

      @media screen and (min-width: $desktop_small)
        min-height: 164px
        height: 164px
        padding: 24px 120px
        box-sizing: border-box

      @media screen and (min-width: $desktop_medium)
        min-height: 213px
        height: auto

      .left-text,
      .right-text
        font-weight: 590
        line-height: 1.3
        text-align: center
        position: relative
        z-index: 1

      .left-text
        transform: rotate(-2deg)
        font-size: 32px
        color: #928AE4

        @media screen and (min-width: $tablet)
          font-size: 34px

        @media screen and (min-width: $desktop_xs)
          font-size: 30px
          width: 333px
          flex: 0 0 auto

        @media screen and (min-width: $desktop_small)
          font-size: 38px
          width: 421px
          white-space: nowrap

        @media screen and (min-width: $desktop_medium)
          font-size: 54px
          width: 600px
          white-space: normal

      .right-text
        transform: rotate(2deg)
        font-size: 32px
        color: #736DCA

        @media screen and (min-width: $tablet)
          font-size: 34px

        @media screen and (min-width: $desktop_xs)
          font-size: 30px
          width: 408px
          flex: 0 0 auto

        @media screen and (min-width: $desktop_small)
          font-size: 38px
          width: 516px
          white-space: nowrap

        @media screen and (min-width: $desktop_medium)
          font-size: 54px
          width: 740px
          white-space: normal

    // Figma: rocket выше слоганов, ниже карточек
    .rocket
      pointer-events: none
      z-index: 2
      overflow: hidden

      img
        display: block
        width: 100%
        height: 100%
        object-fit: contain
        object-position: center bottom

      @media screen and (max-width: #{$desktop_xs - 1px})
        position: relative
        width: 238px
        height: 238px
        margin: -48px 0 8px -100px

      @media screen and (min-width: $tablet) and (max-width: #{$desktop_xs - 1px})
        width: 270px
        height: 221px
        margin: -24px auto 0

      @media screen and (min-width: $desktop_xs)
        position: absolute
        left: 35.74%
        top: 499px
        width: 300px
        height: 245px
        margin: 0

        img
          width: 100%
          height: 122.36%
          max-width: none
          object-fit: cover
          object-position: top center

      // Figma 1440: left 506, top 431, 360×294, img h 122.36% crop
      @media screen and (min-width: $desktop_small)
        left: 506px
        top: 431px
        width: 360px
        height: 294px

      // Figma 1920: left 683, top 443, 450×368
      @media screen and (min-width: $desktop_medium)
        left: 683px
        top: 443px
        width: 450px
        height: 368px
</style>
